import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { authorizeGmail } from '../store/slices/gmailSlice';
import { toast } from 'react-toastify';

const OAuthHandler = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');

    // Only handle Gmail OAuth codes
    if (code && user?.role === 'superadmin') {
      console.log('🔐 Found OAuth code, processing Gmail authorization...');
      
      // Show loading toast
      const loadingToast = toast.loading('Authorizing Gmail access...');
      
      dispatch(authorizeGmail(code)).then((result) => {
        toast.dismiss(loadingToast);
        
        if (result.type === 'gmail/authorize/fulfilled') {
          toast.success('Gmail authorized successfully!');
          // Navigate to Gmail inbox
          navigate('/gmail-inbox', { replace: true });
        } else if (result.type === 'gmail/authorize/rejected') {
          toast.error(`Gmail authorization failed: ${result.payload}`);
          // Navigate to Gmail inbox to show the auth screen again
          navigate('/gmail-inbox', { replace: true });
        }
      }).catch((error) => {
        toast.dismiss(loadingToast);
        toast.error('Gmail authorization failed');
        navigate('/gmail-inbox', { replace: true });
      });
    } else if (error) {
      toast.error(`OAuth error: ${error}`);
      if (user?.role === 'superadmin') {
        navigate('/gmail-inbox', { replace: true });
      }
    }
  }, [dispatch, navigate, location, user]);

  return null; // This component doesn't render anything
};

export default OAuthHandler;